import { css } from '@styled-system/css';
import styled from 'styled-components';

import { glossaryListProps } from 'humanity/components/glossaryList/glossaryList.types.js';
import Box from 'humanity/primitives/box';
import Section from 'humanity/primitives/section';
import Container from 'humanity/primitives/container';
import { theme } from 'utils/theme.v2';
import Link from 'humanity/primitives/link';

const StyledGlossaryContainer = styled(Box)(
  css({
    columnCount: [1, 2, 3],
    backgroundColor: theme.colors.backgroundLightGray2,
    borderRadius: theme.radii.md,
  })
);

const StyledList = styled('ul')(
  css({
    listStyleType: 'none',
  })
);

const StyledTermHeader = styled('strong')(
  css({
    mb: 3,
    display: 'block',
  })
);

const StyledTermListItem = styled('li')(
  css({
    mb: 3,
  })
);

const StyledTermLink = styled(Link)(css({ fontWeight: 'normal' }));

const GlossaryList = ({ list }) => {
  const sortedList = list.sort((a, b) => a?.page?.title?.localeCompare(b?.page?.title));
  const mappedList = sortedList.reduce((acc, item) => {
    const firstLetter = item?.page?.title[0].toUpperCase();

    if (!/^[A-Za-z]$/.test(firstLetter)) {
      if (!acc['#']) {
        // eslint-disable-next-line no-param-reassign
        acc['#'] = [];
      }
      acc['#'].push(item);
      return acc;
    }

    if (!acc[firstLetter]) {
      // eslint-disable-next-line no-param-reassign
      acc[firstLetter] = [];
    }
    acc[firstLetter].push(item);
    return acc;
  }, {});
  return (
    <Container>
      <Section py={7}>
        <StyledGlossaryContainer p={6}>
          <StyledList>
            {Object.keys(mappedList).map((key) => (
              <li key={key}>
                <StyledTermHeader>{key}</StyledTermHeader>
                <StyledList>
                  {mappedList[key].map((item) => (
                    <StyledTermListItem key={item.sys.id}>
                      <StyledTermLink href={`/${item.slug}`}>
                        {item.page.title}
                      </StyledTermLink>
                    </StyledTermListItem>
                  ))}
                </StyledList>
              </li>
            ))}
          </StyledList>
        </StyledGlossaryContainer>
      </Section>
    </Container>
  );
};

GlossaryList.propTypes = {
  ...glossaryListProps,
};

export default GlossaryList;
